module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/staff1-963c21d700a13cd269611c31914a4cc7.jpg";